// eslint-disable-next-line import/prefer-default-export
export const MESSAGE_TYPE = {
  ERROR: 'ERROR',
  CONFIRMATION: 'CONFIRMATION',
  NOTIFICATION: 'NOTIFICATION',
};



// WEBPACK FOOTER //
// ../../src/messages/constants.js